import { render, staticRenderFns } from "./TimePlayedHero.vue?vue&type=template&id=769f1752&scoped=true&"
import script from "./TimePlayedHero.vue?vue&type=script&lang=js&"
export * from "./TimePlayedHero.vue?vue&type=script&lang=js&"
import style0 from "./TimePlayedHero.vue?vue&type=style&index=0&id=769f1752&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f1752",
  null
  
)

export default component.exports